@if (discountType && discountBucketDetails && !isLoading) { @if (discountBucketDetails.onInvoiceDiscounts &&
discountBucketDetails.onInvoiceDiscounts.length > 0) {
<div class="on-invoice-discounts-container">
  <mat-list>
    @for (onInvoiceDiscountsDetail of discountBucketDetails.onInvoiceDiscounts; track onInvoiceDiscountsDetail) {
    <mat-list-item>
      <span>{{ onInvoiceDiscountsDetail.group }}</span>
      <span>{{ onInvoiceDiscountsDetail.discountValue + '%' }}</span>
    </mat-list-item>
    }
  </mat-list>
</div>
} @if (discountBucketDetails.offInvoiceDiscounts && discountBucketDetails.offInvoiceDiscounts.length > 0) {
<div class="off-invoice-discounts-container">
  <h3>{{ 'discounts.offInvoiceDiscounts' | cxTranslate }}</h3>
  <mat-list>
    @for (offInvoiceDiscountsDetail of discountBucketDetails.offInvoiceDiscounts; track offInvoiceDiscountsDetail) {
    <mat-list-item>
      <span>{{ offInvoiceDiscountsDetail.group }}</span>
      <span>{{ offInvoiceDiscountsDetail.discountValue + '%' }}</span>
    </mat-list-item>
    }
  </mat-list>
</div>
} }
